import React, { useState } from "react";
import { Stack } from "@mui/material";
import FilterItem from "@hyro-components/hyro-filter/components/filter-item/FilterItem";

const EMPTY_ARRAY = [];

const DefaultFilters = ({ filters = EMPTY_ARRAY, disabled, onChange }) => {
  const [openFilterKey, setOpenFilterKey] = useState(null);

  if (!filters.length) return null;

  return (
    <Stack direction="row" alignItems="center" gap={1} data-testid="default-filters">
      {filters.map((filter) => (
        <FilterItem
          key={filter.key}
          testId={`default-filter-${filter.key}`}
          id={filter.key}
          label={filter.label}
          value={filter.value}
          type={filter.overrideType || filter.type}
          options={filter.options}
          operator={filter.operator}
          disabled={disabled}
          isDefault
          isActive={openFilterKey === filter.key}
          onClick={() => setOpenFilterKey(filter.key)}
          onClose={() => setOpenFilterKey(null)}
          onChange={({ value, operator }) => onChange(value, filter, operator)}
        />
      ))}
    </Stack>
  );
};

export default DefaultFilters;
